import { SecurityQuestionsBehavioursDto } from '../../interfaces/Dto/SecurityQuestionsBehavioursDto';
import { SecurityQuestionsBehaviours } from '../../interfaces/SecurityQuestionsBehaviours';

export default function transformSecurityQuestionsBehaviours(securityQuestionBehavioursDto: SecurityQuestionsBehavioursDto): SecurityQuestionsBehaviours {
  const securityQuestionBehaviours = {
    answerMaxLength: securityQuestionBehavioursDto?.answerMaxLength,
    answerMinLength: securityQuestionBehavioursDto?.answerMinLength,
    numberOfQuestions: securityQuestionBehavioursDto?.numberOfQuestions,
    regularExpression: new RegExp(securityQuestionBehavioursDto?.regularExpression),
  };
  return securityQuestionBehaviours;
}
